import { Menu, message, Select, Skeleton, Tabs, Tooltip } from "antd";
import AOS from "aos";
import React, { useEffect, useReducer, useState } from "react";
import { fetchAssignedTest } from "../../../api/fetchAssignedTest";
import { cancelFullScreen } from "../../../helper/fullscreen";
import { setLocalStorage } from "../../../helper/localStorage";
import { arrayValidation, objectValidation } from "../../../helper/validation";
import useWindowDimensions from "../../../Hooks/WindowDimensions";
import { AnswerContext } from "../../../store/answerStore";
import { FetchAssignedTestContext } from "../../../store/assignedTestStore";
import { HelperContext } from "../../../store/helperStore";
import { RecorderContext } from "../../../store/recorderStore";
import Filters, {
  GetAudioFilteredTest,
  GetNonAudioFilteredTest,
} from "./filter";
import {
  AAcqKnow,
  AMemPro,
  APerPro,
  AProcessingEff,
  NAAcqKnow,
  NAMemPro,
  NAPerPro,
  NAProcessingEff,
  NAResAbl,
} from "./getSectionTile";
import { NoAnyTestAvail } from "./noAnyTestAvail";
import { AudioInst, NonAudioInst } from "./welcomeInstruction";

const { TabPane } = Tabs;
const { Option } = Select;

// for reducer
const audioValue = {
  name: false,
  latest: false,
  totalTime: false,
  reverse: false,
  search: "",
};

const nonAudioValue = {
  name: false,
  latest: false,
  totalTime: false,
  reverse: false,
  search: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "name":
      return { ...state, name: true, latest: false, totalTime: false };
    case "latest":
      return { ...state, name: false, latest: true, totalTime: false };
    case "totalTime":
      return { ...state, name: false, latest: false, totalTime: true };
    case "reverse":
      return { ...state, reverse: !state.reverse };
    case "SEARCH":
      return { ...state, search: action.payload };
    case "RESET":
      return {
        ...state,
        reverse: false,
        name: false,
        latest: false,
        totalTime: false,
      };

    default:
      return state;
  }
};

const nonAudioReducer = (state, action) => {
  switch (action.type) {
    case "name":
      return { ...state, name: true, latest: false, totalTime: false };
    case "latest":
      return { ...state, name: false, latest: true, totalTime: false };
    case "totalTime":
      return { ...state, name: false, latest: false, totalTime: true };
    case "reverse":
      return { ...state, reverse: !state.reverse };
    case "SEARCH":
      return { ...state, search: action.payload };
    case "RESET":
      return {
        ...state,
        reverse: false,
        name: false,
        latest: false,
        totalTime: false,
      };

    default:
      return state;
  }
};

AOS.init({});

function StartTest() {
  //to cancel reloading part functionally while user taking the test
  setLocalStorage("isScreenReloaded", false);

  //context data
  const { assignedTestC, dispatchAssignedTest } = FetchAssignedTestContext();
  const { _, dispatchAnswer } = AnswerContext();
  const { recorderC, dispatchRecorder } = RecorderContext();
  const { assignedTestData, loader, err } = assignedTestC;

  const [attemptFlag, setAttemptFlag] = useState(null);
  const [filterR, dispatchFilter] = useReducer(reducer, audioValue);
  const [filterNonAudio, dispatchFilterNonAudio] = useReducer(
    nonAudioReducer,
    nonAudioValue
  );

  const gradeId = JSON.parse(localStorage.getItem("gradeId"));

  // const [myGradeId, setMyGradeId] = useState(gradeId);
  const [level, setLevel] = useState(gradeId);
  const { helperC, dispatchHelper } = HelperContext();

  //condition for tests
  const audioTest = assignedTestData && assignedTestData.audio;
  const nonAudioTest = assignedTestData && assignedTestData.non_audio;

  useEffect(() => {
    console.log("datadata isD", helperC.testType);
  }, [helperC.testType]);

  useEffect(() => {
    //fetching test list from the api
    const isAssignedTestAvailable = objectValidation(
      assignedTestC.assignedTestData
    );

    if (!isAssignedTestAvailable) {
      fetchAssignedTest(level, dispatchAssignedTest);
    }
    // if somebody refresh between the test
    dispatchAnswer({ type: "RESET_ANSWER" });
    //remove screen reloading value for clear screen loading value for dashboard demo test
    dispatchHelper({ type: "IS_AUDIO_TEST", payload: true });
    dispatchHelper({ type: "RESET_FS_REMOVE_COUNT" });
    dispatchHelper({ type: "RUNNING_QUES_ID", payload: "" });
    dispatchHelper({ type: "RESET_AUDIO_STAT" });
    dispatchHelper({ type: "OFF_HEIGHT", payload: 0 });
    dispatchRecorder({ type: "RESET_STAT" });
    dispatchHelper({
      type: "FACE_DATA",
      payload: false,
    });

    cancelFullScreen();
  }, []);

  //this function runs on Click on particular test

  //initially ask for microphone permission
  const getAudioPermission = () => {
    if (navigator.mediaDevices) {
      navigator.mediaDevices.getUserMedia(
        { audio: true },
        function (stream) {
          stream.getTracks().forEach((x) => x.stop());
        },
        (err) => console.log(err)
      );
    } else {
      message.error("Your browser does not support audio recording");
    }
  };

  useEffect(() => {
    getAudioPermission();
  }, []);

  const handleLevelChange = (level) => {
    setLocalStorage("gradeId", level);
    fetchAssignedTest(level, dispatchAssignedTest);
    setLevel(level);
  };

  // const { width } = useWindowDimensions();
  const width = false;
  const selectLevel = (
    <Select
      defaultValue="L1"
      value={level}
      className="level"
      onChange={handleLevelChange}
    >
      <Option value="2">{width ? "L" : "Level"} 1</Option>
      <Option value="5">{width ? "L" : "Level"} 2</Option>
      <Option value="8">{width ? "L" : "Level"} 3</Option>
      <Option value="12">{width ? "L" : "Level"} 4</Option>
    </Select>
  );

  const sortByMenu = (testType) => {
    return (
      <Menu>
        <Menu.Item
          onClick={() => {
            testType === "audio"
              ? dispatchFilter({ type: "name" })
              : dispatchFilterNonAudio({ type: "name" });
          }}
        >
          <span>Name</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            testType === "audio"
              ? dispatchFilter({ type: "latest" })
              : dispatchFilterNonAudio({ type: "latest" });
          }}
        >
          <span>Latest</span>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            testType === "audio"
              ? dispatchFilter({ type: "totalTime" })
              : dispatchFilterNonAudio({ type: "totalTime" });
          }}
        >
          <span>Total Time</span>
        </Menu.Item>
      </Menu>
    );
  };

  const getAttemptFlag = (flagValue) => {
    setAttemptFlag(flagValue);
  };

  const filters = (testType) => {
    return (
      <Filters
        filterR={filterR}
        dispatchFilter={dispatchFilter}
        filterNonAudio={filterNonAudio}
        dispatchFilterNonAudio={dispatchFilterNonAudio}
        sortByMenu={sortByMenu}
        getAttemptFlag={getAttemptFlag}
        testType={testType}
      ></Filters>
    );
  };

  const categorizeData = (category, data, type) => {
    const filteredData =
      data && data.data.filter((data) => data.group_name === category);

    const unattempted =
      filteredData &&
      filteredData.filter((testData) => {
        const completeTime = testData.complete_date.split(" ");
        return completeTime[0] === "0000-00-00";
      });
    const attempted =
      filteredData &&
      filteredData.filter((testData) => {
        const completeTime = testData.complete_date.split(" ");
        return completeTime[0] !== "0000-00-00";
      });

    const getTestArr = () => {
      if (attemptFlag === "1") {
        return attempted;
      } else if (attemptFlag === "0") {
        return unattempted;
      } else {
        return filteredData;
      }
    };

    if (arrayValidation(getTestArr())) {
      return getTestArr();
      // <GetTestCard
      //   instVisible={instVisible}
      //   handleInstVisible={handleInstVisible}
      //   testData={getTestArr()}
      //   type={type}
      // />
    } else return undefined;
  };

  const skeletonLoader = () => {
    return (
      <div className="categories-tests skeleton-loader">
        <Skeleton className="card" active />
        <Skeleton className="card" active />
      </div>
    );
  };

  const audioTestData = [
    {
      name: "Processing Efficiency",
      tests: categorizeData("Processing Efficiency", audioTest, "audio"),
    },
    {
      name: "Acquired Knowledge",
      tests: categorizeData("Acquired Knowledge", audioTest, "audio"),
    },
    {
      name: "Perceptual Processes",
      tests: categorizeData("Perceptual Processes", audioTest, "audio"),
    },
    {
      name: "Memory Processes",
      tests: categorizeData("Memory Processes", audioTest, "audio"),
    },
  ];

  const nonAudioTestData = [
    {
      name: "Reasoning Ability",
      tests: categorizeData("Reasoning Ability", nonAudioTest, "nonAudio"),
    },
    {
      name: "Processing Efficiency",
      tests: categorizeData("Processing Efficiency", nonAudioTest, "nonAudio"),
    },
    {
      name: "Acquired Knowledge",
      tests: categorizeData("Acquired Knowledge", nonAudioTest, "nonAudio"),
    },
    {
      name: "Perceptual Processes",
      tests: categorizeData("Perceptual Processes", nonAudioTest, "nonAudio"),
    },
    {
      name: "Memory Processes",
      tests: categorizeData("Memory Processes", nonAudioTest, "nonAudio"),
    },
  ];

  const isAudioFilter =
    !!filterR.search || filterR.name || filterR.latest || filterR.totalTime;
  const isNonAudioFilter =
    !!filterNonAudio.search ||
    filterNonAudio.name ||
    filterNonAudio.latest ||
    filterNonAudio.totalTime;

  return (
    <div className="start-test">
      <Tabs
        keyboard={true}
        defaultActiveKey={helperC.dashboardTab}
        tabBarExtraContent={selectLevel}
        onChange={(e) => {
          dispatchHelper({ type: "DASHBOARD_TAB_MOVE", payload: e });
        }}
      >
        <TabPane
          tab={
            <Tooltip title="Please keep your Headsets & Microphone ready and Take test in a quiet, Noise-free area">
              <span>AUDIO TEST</span>
            </Tooltip>
          }
          key="1"
        >
          {filters("audio")}
          <>
            <div className="start-test__audio">
              {assignedTestC.loader || assignedTestC.err ? (
                skeletonLoader()
              ) : !assignedTestC.isAudioTestAssign ||
                !assignedTestC.isTestAvailable ? (
                <NoAnyTestAvail />
              ) : (
                <>
                  {isAudioFilter ? (
                    <GetAudioFilteredTest
                      filterR={filterR}
                      audioTest={audioTest}
                    />
                  ) : audioTestData.some((testData) => !!testData.tests) ? (
                    <>
                      <AProcessingEff data={audioTestData[0]} />
                      <AAcqKnow data={audioTestData[1]} />
                      <APerPro data={audioTestData[2]} />
                      <AMemPro data={audioTestData[3]} />
                    </>
                  ) : (
                    <NoAnyTestAvail />
                  )}
                </>
              )}
            </div>
            <AudioInst></AudioInst>
          </>
        </TabPane>

        <TabPane
          tab={
            <Tooltip
              title="Type, Tap or Click or use a mouse & keyboard. Assessor will advise whenever a Paper-Pencil can be used.
              "
              placement="bottom"
            >
              <span>NON AUDIO TEST</span>
            </Tooltip>
          }
          key="2"
        >
          {filters("nonAudio")}
          <>
            <div className="start-test__nonAudio">
              {assignedTestC.loader || assignedTestC.err ? (
                skeletonLoader()
              ) : !assignedTestC.isNonAudioTestAssign ||
                !assignedTestC.isTestAvailable ? (
                <NoAnyTestAvail />
              ) : (
                <>
                  {isNonAudioFilter ? (
                    <GetNonAudioFilteredTest
                      filterNonAudio={filterNonAudio}
                      nonAudioTest={nonAudioTest}
                    />
                  ) : nonAudioTestData.some((testData) => !!testData.tests) ? (
                    <>
                      <NAResAbl data={nonAudioTestData[0]} />
                      <NAProcessingEff data={nonAudioTestData[1]} />
                      <NAAcqKnow data={nonAudioTestData[2]} />
                      <NAPerPro data={nonAudioTestData[3]} />
                      <NAMemPro data={nonAudioTestData[4]} />
                    </>
                  ) : (
                    <NoAnyTestAvail />
                  )}
                </>
              )}
            </div>
            <NonAudioInst></NonAudioInst>
          </>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default StartTest;
